<div class="authentication__wrap">
  <div class="error-image">
    <div class="loginWrapper height100">
      <div class="row height100">
        <div class="col-sm-6 col-md-6 col-12">
          <div class="container__image login_page">
            <app-slider></app-slider>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-12 height100">
          <div class="login__form d-flex height100 align-items-center justify-content-center">
            <div class="overFlowAuto">
              <div class="container__form">
                <router-outlet></router-outlet>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
